export default __webpack_public_path__ + "static/media/to.4173b316.svg";